module.exports = __webpack_public_path__ + "static/media/97.83f68519.gif";